import React from 'react';
import WarningIcon from '../../../../assets/Warningnote.png';

const LoginNote = ({ showNote, resetPasswordNoteDate }) => {
  if (!showNote) return null;

  return (
    <div style={{
      border: '2px solid yellow',
      backgroundColor: 'rgb(255, 248, 225)',
      padding: '0rem',
      display: 'flex',
      alignItems: 'center',
      marginTop: '0.5rem',
      marginBottom: '2rem',  
      width: '85%',  
      boxSizing: 'border-box',
      borderRadius: '5px',
      height: '10vh',  
      overflow: 'hidden',
      margin: '0 auto'  
    }}>
      <div style={{
        backgroundColor: '#FFD700',
        padding: '0.5rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '40px',
        height: '100%',
        borderRadius: '5px 0 0 5px'
      }}>
        <img src={WarningIcon} alt="Warning" style={{ width: '30px', height: '30px' }} />
      </div>
      <div style={{ flex: 1, padding: '1rem', paddingLeft: '1rem', paddingRight: '1rem', fontSize: '0.85rem' }}>
        If your last login was before {resetPasswordNoteDate}, you'll need to reset your password via 'Forgot Password' on the next page.
      </div>
    </div>
  );
};

export default LoginNote;